
export function useWhatsappUrl(text) {
  const tag = new URLSearchParams(window.location.search)?.get('tag')
  const phone = '554831997783'
  const tagText = tag ? `(${tag}) ` : ''
  const message = encodeURIComponent(`${tagText}${text}`)

  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phone}&text=${message}&app=facebook&entry_point=page_cta`

  return { whatsappUrl, tagText, phone }
}
